<template>
	<div class="academy-search">
		<h2 class="">Academy Search</h2>
		<div>
			<input v-model="extCompRef" type="text" class="text-input bg-white" placeholder="extCompRef"/>
			<span>and/or</span>
			<input v-model="acadid" type="text" class="text-input bg-white" placeholder="Schoox Academy ID"/>
			<button v-on:click="search" class="button raised">Search</button>
		</div>
		<p v-show="err" class="text-danger">{{err}}</p>
		<div v-if="searched" class="search-results">
			<h3>Search Results</h3>
			<div v-if="resultsCount == 0">
				<p>No records found</p>
			</div>
			<div v-else>
				<div>
					<v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
				</div>
			</div>
		</div>

		<div class="search-results"></div>
	</div>
</template>

<script>
import _ from 'underscore'
import store from '../data/AppData'

const rowMapper = row => {
	return {
		'Academy ID': row.acadid,
		'Academy Name': row.acadname,
		'Customer': row.company,
		'Last HRID Sync': row.lastrun,
		'extCompRef': row.extCompRef,
		'Location/Node': row.description,
		'HRID sync': 'ON',
		'ASC user sync': 'ON',
		'Location/Node ID': row.nodeid
	}
}

export default {
	name: 'academysearch',
	data () {
		return {
			extCompRef: null,
			acadid: null,
			err: null,
			results: [],
			searched: false,
			columns: [ 'extCompRef', 'Academy ID', 'Academy Name', 'Customer', 'Location/Node', 'Location/Node ID', 'HRID sync', 'ASC user sync', 'Last HRID Sync', 'Details' ],
			options: {
				perPage: 25,
				templates: {
					'Details': (h, row) => { return h('details-link', { attrs: { 'id': row['Academy ID'] } }) }
				},
				filterable: false
			}
		}
	},
	computed: {
		resultsCount () {
			return this.results.length
		},
		tableData () {
			return _.map(this.results, rowMapper)
		}
	},
	methods: {
		search () {
			let query = {}
			this.err = null

			if (!_.isEmpty(this.extCompRef)) {
				// this is always a string
				query.extCompRef = this.extCompRef
			}
			if (!_.isEmpty(this.acadid)) {
				// this is always a number
				query.acadid = parseInt(this.acadid)
			}

			// console.log('search query', query)
			if (_.isEmpty(query)) {
				this.err = 'You must enter a Academy Id or a extCompRef'
			} else {
				this.results = _.where(this.$store.state.academies, query)
				this.searched = true
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		if (store.state.academiesLoaded) return next()
		store.dispatch('getAcademies').then(res => next())
	}
}
</script>

<style>
.academy-search .text-input{
	margin:0  0.2em;
	padding: 0.2em;
}
.academy-search  .button{
    padding: 0.2em;
}
.search-results th{
	vertical-align: top !important;
}
.search-results tr td, .search-results tr th{
	text-align: center;
}

.search-results tr td:nth-child(3), .search-results tr td:nth-child(4), .search-results tr td:nth-child(5),
.search-results tr th:nth-child(3), .search-results tr th:nth-child(4), .search-results tr th:nth-child(5) {
	text-align: left;
}
.search-results  .VuePagination{
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// AcademySearch.vue?bb6dd7bc